<div class="ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

  <div class="col-md-10 offset-md-1" [hidden]="isLoading">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item>
        <div [innerHTML]="'tkey;admin.email_configuration.card.message' | escapeHtml"></div>
      </ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>

    <ziro-collapsible-section-card
      [isSwitchHidden]="true"
      [title]="'tkey;admin.email_configuration.card.label'"
      [isCollapsible]="false"
    >
      <ziro-text [fieldId]="'host'"></ziro-text>
      <ziro-text [fieldId]="'port'"></ziro-text>
      <ziro-select [fieldId]="'transportStrategy'"></ziro-select>
      <ziro-text [fieldId]="'username'"></ziro-text>
      <ziro-text [fieldId]="'password'"></ziro-text>
      <ziro-text [fieldId]="'from'"></ziro-text>
    </ziro-collapsible-section-card>
  </div>
</div>

<ziro-bottom-nav></ziro-bottom-nav>
